import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import apiUrl from "../../Apiurl";
import stilePulsanti from "../../interfaccia/stilePulsanti";

const CSV_HEADERS = [
  "codVS",
  "idPS",
  "pubblicato",
  "cat_principale",
  "stock",
  "visibility",
];
const QUERY_SQL = `SELECT 
p.id_product AS idPS,
p.reference AS codVS,
fv3l.value AS pubblicato,
cl.name AS cat_principale,
sa.quantity AS stock,
SUBSTRING_INDEX(GROUP_CONCAT(pi.id_image ORDER BY pi.cover DESC SEPARATOR '-'), '-', 1) AS immagine,
m.name AS brand,
fv1l.value AS codProd,
fv2l.value AS shortName,
pl.name AS titolo,
p.visibility
FROM ps_product p
-- Feature 453 (codProd)
LEFT JOIN ps_feature_product fp1 ON p.id_product = fp1.id_product AND fp1.id_feature = 453
LEFT JOIN ps_feature_value_lang fv1l ON fp1.id_feature_value = fv1l.id_feature_value AND fv1l.id_lang = (
    SELECT id_lang FROM ps_lang WHERE iso_code = 'it' LIMIT 1
)
-- Feature 481 (shortName)
LEFT JOIN ps_feature_product fp2 ON p.id_product = fp2.id_product AND fp2.id_feature = 481
LEFT JOIN ps_feature_value_lang fv2l ON fp2.id_feature_value = fv2l.id_feature_value AND fv2l.id_lang = (
    SELECT id_lang FROM ps_lang WHERE iso_code = 'it' LIMIT 1
)
-- Feature 502 (pubblicato)
LEFT JOIN ps_feature_product fp3 ON p.id_product = fp3.id_product AND fp3.id_feature = 502
LEFT JOIN ps_feature_value_lang fv3l ON fp3.id_feature_value = fv3l.id_feature_value AND fv3l.id_lang = (
    SELECT id_lang FROM ps_lang WHERE iso_code = 'it' LIMIT 1
)
-- Titolo prodotto in italiano
LEFT JOIN ps_product_lang pl ON p.id_product = pl.id_product AND pl.id_lang = (
    SELECT id_lang FROM ps_lang WHERE iso_code = 'it' LIMIT 1
)
-- Immagine di default
LEFT JOIN ps_image pi ON p.id_product = pi.id_product AND pi.cover = 1
-- Categoria principale
LEFT JOIN ps_category_lang cl ON p.id_category_default = cl.id_category AND cl.id_lang = (
    SELECT id_lang FROM ps_lang WHERE iso_code = 'it' LIMIT 1
)
-- Stock
LEFT JOIN ps_stock_available sa ON p.id_product = sa.id_product
-- Manufacturer (brand)
LEFT JOIN ps_manufacturer m ON p.id_manufacturer = m.id_manufacturer
GROUP BY p.id_product
ORDER BY m.name ASC, p.reference DESC;`;

function CSVuploadQuery130stock() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [statusMessage, setStatusMessage] = useState("In attesa dell'upload");
  const [responseMeta, setResponseMeta] = useState(null);
  const [skippedRows, setSkippedRows] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { getAccessTokenSilently, user } = useAuth0();
  const [token, setToken] = useState("");

  const { buttonClassesWhite, tastoCopiaAspetto } = stilePulsanti;

  useEffect(() => {
    let mounted = true;
    const fetchToken = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        if (mounted) {
          setToken(accessToken);
        }
      } catch (error) {
        console.error("Errore nel recupero del token:", error);
      }
    };
    fetchToken();
    return () => {
      mounted = false;
    };
  }, [getAccessTokenSilently, user?.sub]);

  const changeHandler = (event) => {
    const file = event.target.files?.[0] ?? null;
    setSelectedFile(file);
    setIsFilePicked(Boolean(file));
    setStatusMessage("In attesa dell'upload");
    setResponseMeta(null);
    setSkippedRows([]);
  };

  const handleSubmission = async () => {
    if (!token) {
      setStatusMessage("Token assente, attendere qualche secondo e riprovare.");
      return;
    }
    if (!selectedFile) {
      setStatusMessage("Seleziona un file CSV prima di procedere.");
      return;
    }

    setIsSubmitting(true);
    setStatusMessage("Upload in corso...");
    setResponseMeta(null);
    setSkippedRows([]);

    try {
      const formData = new FormData();
      formData.append("file", selectedFile);

      const response = await axios.post(
        `${apiUrl}/moda/articoli/import/csv/stock`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const payload = response?.data ?? {};
      setResponseMeta(payload.meta ?? null);
      setSkippedRows(
        Array.isArray(payload.skippedRows) ? payload.skippedRows : []
      );

      if (payload.success) {
        setStatusMessage("Import completato con successo.");
      } else {
        setStatusMessage(payload.error ?? "Import completato con avvisi.");
      }
    } catch (error) {
      console.error("Errore durante l'import CSV:", error);
      const payload = error?.response?.data ?? {};
      setStatusMessage(
        payload.error ??
          error?.message ??
          "Errore durante l'import. Verifica il formato del file e riprova."
      );
      setResponseMeta(payload.meta ?? null);
      setSkippedRows(
        Array.isArray(payload.skippedRows) ? payload.skippedRows : []
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCopyHeaders = () => {
    navigator.clipboard.writeText(CSV_HEADERS.join(";"));
  };

  return (
    <div className="flex colonnaTuttaPagina">
      <div className="w-30 fr pl4 pr4">
        <h1>Query / Import 130</h1>
        <p>
          Carica il CSV con i risultati della query 130 (delimitatore{" "}
          <code>;</code>) per aggiornare i campi aggiuntivi degli articoli Moda.
          Il file non deve superare i 15&nbsp;MB.
        </p>
        <p>
          Colonne riconosciute (case-insensitive):{" "}
          <strong>{CSV_HEADERS.join(", ")}</strong>. Altre colonne vengono
          ignorate.
        </p>
        <input type="file" accept=".csv" name="file" onChange={changeHandler} />
        {isFilePicked ? (
          <div className="mt2 f6">
            <p>Nome file: {selectedFile?.name}</p>
            <p>Dimensione: {selectedFile?.size?.toLocaleString()} byte</p>
            {selectedFile?.lastModified ? (
              <p>
                Ultima modifica:{" "}
                {new Date(selectedFile.lastModified).toLocaleString("it-IT")}
              </p>
            ) : null}
          </div>
        ) : (
          <p className="mt2">Seleziona un file CSV con intestazione.</p>
        )}
        <div>
          <button
            onClick={handleSubmission}
            disabled={!selectedFile || isSubmitting}
            className="f6 link dim ba b--dark-green ph3 pv2 mt4 dib white bg-dark-green br3 mr2 w-70 center"
          >
            {isSubmitting ? "Caricamento..." : "Carica"}
          </button>
        </div>
        <p className="mt3">{statusMessage}</p>
        {responseMeta && (
          <div className="mt3 f6">
            <h3 className="mt0">Esito import</h3>
            <ul className="pl3">
              <li>Ricevute: {responseMeta.received ?? "-"}</li>
              <li>Processate: {responseMeta.processed ?? "-"}</li>
              <li>Record aggiornati: {responseMeta.affected ?? "-"}</li>
              <li>
                Scartate in parse: {responseMeta.skippedDuringParse ?? "-"}
              </li>
              <li>
                Scartate in upsert: {responseMeta.skippedDuringUpsert ?? "-"}
              </li>
              <li>
                Codici VS mancanti:{" "}
                {Array.isArray(responseMeta.missingCodVS)
                  ? responseMeta.missingCodVS.length
                  : 0}
              </li>
            </ul>
            {Array.isArray(responseMeta.missingCodVS) &&
              responseMeta.missingCodVS.length > 0 && (
                <details className="mt2">
                  <summary>Elenco codici VS non trovati</summary>
                  <pre className="pa2 bg-near-white br2 mt2">
                    {responseMeta.missingCodVS.join("\n")}
                  </pre>
                </details>
              )}
          </div>
        )}
      </div>
      <div className="w-50 fr sezioneConScroll colonna90vh">
        <div className="pa4">
          <button onClick={handleCopyHeaders} className={buttonClassesWhite}>
            {tastoCopiaAspetto}
          </button>
          <span className="ml2">
            Copia intestazione CSV ({CSV_HEADERS.join(";")})
          </span>
        </div>
        <div className="pa4 bt bordoColAlt">
          <h3 className="mt0">Righe scartate</h3>
          {skippedRows.length === 0 ? (
            <p className="gray">Nessuna riga scartata.</p>
          ) : (
            <pre className="pa3 bg-near-white br3 sezioneConScroll">
              {JSON.stringify(skippedRows, null, 2)}
            </pre>
          )}
        </div>
        <div className="pa4 bt bordoColAlt">
          <h3 className="mt0">
            Query 130 (Prestashop) - Solo stock e visibility
          </h3>
          <div className="mb2">
            <button
              onClick={() => navigator.clipboard.writeText(QUERY_SQL)}
              className={buttonClassesWhite}
            >
              {tastoCopiaAspetto}
            </button>
            <span className="ml2">
              Copia la query da eseguire su Prestashop
            </span>
          </div>
          <pre className="pa3 bg-near-white br3 sezioneConScroll">
            {QUERY_SQL}
          </pre>
        </div>
        <div className="pa4 bt bordoColAlt">
          <h3 className="mt0">Note operative</h3>
          <ul className="pl3">
            <li>
              L&apos;endpoint POST <code>/moda/articoli/import/csv</code>{" "}
              richiede autenticazione e permesso <code>puoModificareCose</code>.
            </li>
            <li>
              Il campo obbligatorio del FormData è <code>file</code>.
            </li>
            <li>Solo i campi stock e visibility vengono sovrascritti.</li>
            <li>
              Le righe con codVS assente in MODA_Articoli vengono ignorate e
              riportate in missingCodVS.
            </li>
            <li>
              Dopo l&apos;import è consigliato aggiornare la lista Moda
              articoli.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CSVuploadQuery130stock;
